<section class="contact-page py-5">
  <div class="container">
    <div class="contact-hero mb-4">
      <div>
        <p class="eyebrow mb-2">Contact Upcoming Cars</p>
        <h1 class="mb-2">Let’s find your next car, together</h1>
        <p class="mb-0">Have a question, want to list a car, or need help comparing models? Our team is ready to help.</p>
      </div>
      <a class="hero-mail" href="mailto:piyushanandbang@gmail.com?subject=Upcoming%20Cars%20Inquiry">Send inquiry</a>
    </div>

    <div class="contact-grid">
      <article class="contact-card">
        <span class="contact-icon" aria-hidden="true">☎</span>
        <h3 class="h5">Phone</h3>
        <a href="tel:+918210508660">+91 8210508660</a><br>
        <a href="tel:+919916385146">+91 9916385146</a>
      </article>

      <article class="contact-card">
        <span class="contact-icon" aria-hidden="true">✉</span>
        <h3 class="h5">Email</h3>
        <a href="mailto:piyushanandbang@gmail.com">piyushanandbang@gmail.com</a>
      </article>

      <article class="contact-card">
        <span class="contact-icon" aria-hidden="true">↗</span>
        <h3 class="h5">Website</h3>
        <a [href]="siteUrl" target="_blank" rel="noopener">Upcoming Cars</a>
      </article>
    </div>

    <div class="partner-card mt-4">
      <div>
        <h3 class="h5">Business &amp; Partnership Inquiries</h3>
        <p>We actively collaborate with automotive brands, EV teams, creators, reviewers, and technology partners.</p>
        <p class="mb-0"><strong>Founder:</strong> Piyush Kumar Anand</p>
      </div>
      <div class="response-card" aria-label="Typical response time">
        <strong>&lt;24h</strong>
        <span>Typical response window</span>
      </div>
    </div>
  </div>
</section>
